import React, { useEffect } from "react";
import _ from 'underscore';
import { Form, Input, DatePicker, TimePicker, Select, Button, message } from 'antd';
import moment from 'moment'
import statusArray from './utils/day-type-requests/status';
import dayTypesArray from '../Schedule/utils/live-schedules/drop-down-tables/dayTypes';
import AuthLogic from '../../AuthLogic';
import authLogic from "../../AuthLogic";

const { Option } = Select;

const datePickerFormat = 'MMM Do'
const timePickerFormat = 'h:mmA';

const ResourceDayTypesCalendarGeneralForm = ({ contextMenuKey, resourceDayTypeDetails, dayTypesAllWithoutForceTour, dayTypesAllowingTourScheduling, ...props }) => {

  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;
  const { selectedDates } = props;

  let multipleSelectedDates = selectedDates && selectedDates.length > 1 ? true : false;

  useEffect(() => { // set form values
    const form = props.form;
    const fetchDayTypesAllowingTourScheduling = async () => {
      await props.getDayTypesAllowingTourScheduling(selectedDates);
    }

    form.setFieldsValue({
      comment: resourceDayTypeDetails.comment ? resourceDayTypeDetails.comment : '',
      myComment: resourceDayTypeDetails.myComment ? resourceDayTypeDetails.myComment : '',
      tkComment: resourceDayTypeDetails.TKComment ? resourceDayTypeDetails.TKComment : '',
    });

    fetchDayTypesAllowingTourScheduling();
    if (selectedDates.length === 1) {
      form.setFieldsValue({
        date: moment(selectedDates[0]),
      });
    }
    //we only want to explicitly set this field if there is a day type on the day
    if (resourceDayTypeDetails.dayType) {
      form.setFieldsValue({
        dayType: resourceDayTypeDetails.dayType,
      });
    }
  }, [resourceDayTypeDetails]);

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const validateForm = () => { // validates the whole form
    const form = props.form;

    const dayType = form.getFieldValue('dayType');
    const comment = form.getFieldValue('comment');
    const myComment = form.getFieldValue('myComment');
    const tkComment = form.getFieldValue('tkComment');

    let dayTypeErrors = [];
    if (!dayType) {
      dayTypeErrors.push(new Error('Please input a day type!!'))
    }
    if (dayTypeErrors.length > 0) {
      form.setFields({
        dayType: {
          value: dayType,
          errors: dayTypeErrors,
        }
      });
    } else {
      form.setFields({
        dayType: {
          value: dayType,
        }
      });
    }

    let commentErrors = [];
    if (comment && comment.length > 250) {
      commentErrors.push(new Error('Maximum length is 250 characters!'))
    }
    if (commentErrors.length > 0) {
      form.setFields({
        comment: {
          value: comment,
          errors: commentErrors,
        }
      });
    } else {
      form.setFields({
        comment: {
          value: comment,
        }
      });
    }

    let myCommentErrors = [];
    if (myComment && myComment.length > 250) {
      myCommentErrors.push(new Error('Maximum length is 250 characters!'))
    }
    if (myCommentErrors.length > 0) {
      form.setFields({
        myComment: {
          value: myComment,
          errors: myCommentErrors,
        }
      });
    } else {
      form.setFields({
        myComment: {
          value: myComment,
        }
      });
    }

    let tkCommentErrors = [];
    if (tkComment && tkComment.length > 250) {
      tkCommentErrors.push(new Error('Maximum length 250 characters!'))
    }
    if (tkCommentErrors.length > 0) {
      form.setFields({
        tkComment: {
          value: tkComment,
          errors: tkCommentErrors,
        }
      });
    } else {
      form.setFields({
        tkComment: {
          value: tkComment,
        }
      });
    }
  }

  const handleCreate = () => {
    validateForm();
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      let formValues = getFieldsValue()
      if (multipleSelectedDates) { //add selectedDates
        formValues.useSelectedDates = true;
        console.log('Success! Received values of form: ', formValues)
        props.createMultipleDayTypeRequests(formValues);
      } else {
        console.log('Success! Received values of form: ', formValues)
        props.createDayTypeRequest(formValues);
      }
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  }

  const handleUpdate = () => {
    const errors = {};
    // collect all fields currently in error state
    for (const [field, error] of Object.entries(getFieldsError())) {
      if (error) {
        errors[`${field}`] = error;
      }
    }
    if (Object.values(errors).length === 0) {
      let formValues = getFieldsValue()
      console.log('Success! Received values of form: ', formValues)
      props.updateDayTypeRequest(formValues, resourceDayTypeDetails);
    } else {
      invalidForm();
      console.log('Invalid Form! ', errors);
    }
  }

  const handleDelete = () => {
    if (resourceDayTypeDetails.resourceDayTypeId) {
      props.deleteDayTypeRequest(resourceDayTypeDetails.resourceDayTypeId);
    } else {
      message.config({
        top: 150,
        duration: 5,
        maxCount: 5,
      });
      message.error('Could not perfom delete on this request');
    }
  }

  return (
    <Form>

      <Form.Item
        label="Resource Name"
        style={{ display: "flex", marginBottom: 5 }}
      >
        <Input
          name="resourceName"
          value={props.resource.name}
          disabled
          size={'large'}
          placeholder={''} />
      </Form.Item>

      {contextMenuKey && multipleSelectedDates
        ?
        (
          <Form.Item
            label="Date"
            style={{ display: "flex", marginBottom: 5 }}
          >
            {selectedDates.map((date, index) => {
              return <p key={index} >{date}</p>
            })}
          </Form.Item>
        )
        : (
          <Form.Item
            label="Date"
            style={{ display: "flex", marginBottom: 5 }}
          >
            {getFieldDecorator('date', {
              rules: [
                {
                  required: true,
                  message: 'Please input a date!'
                },
              ],
            })(
              <DatePicker
                name="date"
                // showTime={{ format: datePickerFormat, use12Hours: true }}
                onChange={(e) => props.handleDateChange(e, validateForm)}
                allowClear={false}
                placeholder={'Select date and time'}
                format={datePickerFormat}
                size={'large'}
                popupStyle={{ zIndex: 2000 }}
              />
            )}
          </Form.Item>
        )}


      <Form.Item
        label="Day Type"
        style={{ display: "flex", marginBottom: 5 }}
      >
        {getFieldDecorator('dayType', {
          rules: [{
            required: true, message: 'Please input a day type!',
          }],
        })(
          <Select
            name='dayType'
            onChange={(e) => props.handleDayTypeChange(e, validateForm)}
            allowClear={false}
            style={{ width: 250 }}
            dropdownStyle={{ zIndex: 2000 }}
            placeholder={'Choose a day type'}
          >
            {/* TODO: make an accurate list of day types */}
            {dayTypesAllowingTourScheduling && dayTypesAllowingTourScheduling.length > 0 ?
              (
                dayTypesAllowingTourScheduling.map((dayTypeOption, index) => {
                  return <Option key={index} value={dayTypeOption.dayTypeName} >{dayTypeOption.dayTypeName}</Option>
                })
              )
              :
              (
                dayTypesAllWithoutForceTour.map((dayTypeOption, index) => {
                  return <Option key={index} value={dayTypeOption.dayTypeName} >{dayTypeOption.dayTypeName}</Option>
                })
              )
            }
          </Select>
        )}
      </Form.Item>

      <Form.Item
        label="Comment"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('comment', {})(
          <Input.TextArea
            name="comment"
            style={{ resize: "none" }}
            onChange={(e) => props.handleCommentChange(e, validateForm)}
            size={'large'}
            placeholder={'Enter text here.'} />
        )}
      </Form.Item>

      <Form.Item
        label="My Comment"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('myComment', {})(
          <Input.TextArea
            name="myComment"
            style={{ resize: "none" }}
            onChange={(e) => props.handleMyCommentChange(e, validateForm)}
            size={'large'}
            placeholder={'Enter text here.'} />
        )}
      </Form.Item>

      <Form.Item
        label="TK Comment"
        style={{ marginBottom: 5 }}
      >
        {getFieldDecorator('tkComment', {})(
          <Input.TextArea
            name="tkComment"
            style={{ resize: "none" }}
            onChange={(e) => props.handleTKCommentChange(e, validateForm)}
            size={'large'}
            placeholder={'Enter text here.'} />
        )}
      </Form.Item>

      {
        contextMenuKey
          ?
          <React.Fragment>
            {AuthLogic.changeDayType(props.user) && (
              <Form.Item
                style={{ marginTop: 20 }}
              >
                <Button type="primary" size={'large'} onClick={handleCreate}>
                  Create
              </Button>
              </Form.Item>
            )}
          </React.Fragment>
          :
          <React.Fragment>
            <Form.Item
              style={{ marginTop: 20 }}
            >
              {AuthLogic.changeDayType(props.user) && (
                <Button type="primary" size={'large'} onClick={handleUpdate}>
                  Update
                </Button>
              )}

              {AuthLogic.changeDayType(props.user) && (
                <Button type="danger" size={'large'} onClick={handleDelete}>
                  Delete
                </Button>
              )}
            </Form.Item>
          </React.Fragment>
      }
    </Form >
  );
}

const WrappedResourceDayTypesCalendarForm = Form.create()(ResourceDayTypesCalendarGeneralForm);
export default WrappedResourceDayTypesCalendarForm;



// WEBPACK FOOTER //
// ./src/Components/DayType/ResourceDayTypesCalendarGeneralForm.js